import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import CartContext from './context';
import { cartReducer } from './reducer';

export const StoreProvider = ({ children }) => {
  const initialState = {
    items: [],
    amount: 0,
    user: {},
  };

  const [cart, dispatch] = useReducer(cartReducer, initialState, () => {
    const localData = localStorage.getItem('cart');
    return localData ? JSON.parse(localData) : initialState;
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StoreProvider;
